import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  style: {"min-height":"100%"},
  class: "mtop-10"
}
const _hoisted_3 = {
  key: 0,
  class: "psides-10 w-maxC mtop-10 mleft-15"
}
const _hoisted_4 = ["src"]

import loadingSpinner from "@/views/loadingSpinner.vue";

import patientapi from "@/api/patientapi"
import gen from "@/functions/general.js"
import { ref, computed, watch } from 'vue'
import { useUiStore } from '@/stores/ui'
import { useCurrentEntryStore } from '@/stores/currentEntry'
import { toastError, toastSuccess } from '@/utils/toast-utils'
import { ApiError } from '@/models/share.model'
import { useToast } from 'primevue'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'dashbResultDocument',
  setup(__props) {

const currentEntryStore = useCurrentEntryStore()
const uiStore = useUiStore()
const toast = useToast();
const { t } = useI18n();

const exprTerm = computed(() => {
  return uiStore.dashBoardItem?.originalText;
})

const fileType = computed(() => {
  return  uiStore.dashBoardItem?.resultDocumentFile.fileType || ""
})

const fileMime = computed(() => {
  return  uiStore.dashBoardItem?.resultDocumentFile.mimeType || ""
})

const fileExtension = computed(() => {
  return uiStore.dashBoardItem?.resultDocumentFile.fileExtension.toLowerCase() || "";
})

const isXml = computed(() => {
  return fileExtension.value === 'xml' || fileMime.value.includes('xml');
})

const isInterpretable = computed(() => {
  return(uiStore.dashBoardItem.isInterpretable);
})

const isFromCurrentEntry = computed(() => {
  return (currentEntryStore.currentEntryId === uiStore.dashBoardItem.entry.relationshipId)
})

const localFileBlob = ref(null);
const localFileUrl = ref(null);

async function getFile() {
  if (!uiStore.dashBoardItem?.expressionCcl.expressionCclId) return;
  //Clear
  localFileBlob.value = null
  localFileUrl.value = null
  //Check
  if (uiStore.dashBoardItem.expressionType !== "ResultDocument") {console.log("Error. Not a ResultDocument"); return;}
  //API
  const expression_CclId = uiStore.dashBoardItem.expressionCcl.expressionCclId
  const respBlob = await patientapi.getResultDocumentStream(expression_CclId)
  //Fill
  localFileBlob.value = respBlob
  const myBlob = new Blob([respBlob], {type: respBlob.type})
  localFileUrl.value = window.URL.createObjectURL(myBlob)
}

async function deleteResultDocumentFile() {
  if (!uiStore.dashBoardItem) return;
  //Check
  if (uiStore.dashBoardItem.expressionType !== "ResultDocument") {console.log("Error. Not a ResultDocument"); return;}

  //Update FrontEnd and Backend
  const expression_CclId = uiStore.dashBoardItem.expressionCcl.expressionCclId  
  uiStore.clearDashBoard()
  patientapi.deleteExpression(expression_CclId, currentEntryStore.currentEntryId, undefined).then(() => {
      toastSuccess(toast, {
          summary: t('common.toast.success.delete'),
          detail:  t('common.toast.success.delete')
      });
      currentEntryStore.reloadCurrentEntry()
    }).catch((error: ApiError) => {
      toastError(toast, {
          summary: t('common.toast.error'),
          detail: t(`error.${error.status}`)
      });
    });
}

function downloadFile() {
  if (!localFileBlob.value) {return}
  const fileName = uiStore.dashBoardItem?.text
  const fileExtension = uiStore.dashBoardItem.resultDocumentFile.fileExtension
  gen.downloadBlob(localFileBlob.value, fileName, fileExtension)
}

const isConverting = ref(false);

async function fileToResults() {
  const expression_CclId = uiStore.dashBoardItem.expressionCcl.expressionCclId;
  const isCurrentEntry = isFromCurrentEntry.value;
  isConverting.value = true;
  try {
    await patientapi.fileToResults(expression_CclId);
    if (isCurrentEntry) {
      await currentEntryStore.reloadCurrentEntry();
    } else {
      currentEntryStore.requestCsListRefresh();
    }
    uiStore.clearDashBoard();
  } catch (error) {
    const apiError = error as ApiError;
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: t(`error.${apiError.status}`)
    });
  } finally {
    isConverting.value = false;
  }
}

function printFile() {
  if (!localFileBlob.value) {return}
  const fileType = uiStore.dashBoardItem?.resultDocumentFile.fileType  //"Image" "Pdf"
  gen.printBlob(localFileBlob.value, fileType)
}

watch(
  () => uiStore.dashBoardItem?.expressionCclId,
  () => {getFile()},
  { immediate: true }
)


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_text_item, {
        txt: exprTerm.value,
        styles: "font-xl"
      }, null, 8, ["txt"]),
      (isFromCurrentEntry.value)
        ? (_openBlock(), _createBlock(_component_buttonGroup, {
            key: 0,
            class: "mleft-04",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteResultDocumentFile()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_item, {
                icon: "trash",
                styles: "main-l"
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (localFileBlob.value)
        ? (_openBlock(), _createBlock(_component_buttonGroup, {
            key: 1,
            class: "mleft-30",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (downloadFile()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_item, {
                icon: "download",
                styles: "main-m"
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (['Pdf', 'Image'].includes(fileType.value) && localFileBlob.value)
        ? (_openBlock(), _createBlock(_component_buttonGroup, {
            key: 2,
            class: "mleft-04",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (printFile()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_item, {
                icon: "printer",
                styles: "main-m"
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (!localFileUrl.value)
        ? (_openBlock(), _createBlock(_component_text_item, {
            key: 0,
            txt: _unref(t)('common.loading'),
            styles: "main-m",
            class: "mtop-04 mleft-04"
          }, null, 8, ["txt"]))
        : (['Other'].includes(fileType.value))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.resultDocument.file', { mime: fileMime.value }),
                styles: "font-mBold",
                class: "mtop-30 mleft-04"
              }, null, 8, ["txt"]),
              (!isXml.value)
                ? (_openBlock(), _createBlock(_component_text_item, {
                    key: 0,
                    txt: _unref(t)('patient.resultDocument.cannotDisplay'),
                    styles: "main-m",
                    class: "mtop-04 mleft-04 linebreak"
                  }, null, 8, ["txt"]))
                : _createCommentVNode("", true),
              (isInterpretable.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (isConverting.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createVNode(loadingSpinner, {
                            logo: false,
                            style: 'w-3'
                          })
                        ]))
                      : (isXml.value)
                        ? (_openBlock(), _createBlock(_component_buttonGroup, {
                            key: 1,
                            class: "mleft-04 mtop-06 border-h",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (fileToResults()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_svg_item, {
                                icon: "text",
                                styles: "main-m",
                                class: "mtop-01"
                              }),
                              _createVNode(_component_text_item, {
                                txt: _unref(t)('patient.resultDocument.createStructuredData'),
                                class: "mleft-04"
                              }, null, 8, ["txt"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createBlock(_component_text_item, {
                    key: 2,
                    txt: _unref(t)('patient.resultDocument.notInterpretable'),
                    styles: "main-m",
                    class: "mleft-04 linebreak"
                  }, null, 8, ["txt"]))
            ], 64))
          : (_openBlock(), _createElementBlock("iframe", {
              key: 2,
              src: localFileUrl.value,
              scrolling: "yes",
              frameborder: "0",
              style: {"height":"87vh","width":"100%"}
            }, null, 8, _hoisted_4))
    ])
  ], 64))
}
}

})